module.exports = __webpack_public_path__ + "img/ztLogo.0bbc79cf.png";